/* ---------------------------------------------------------------------------
 * SOLVEX lux — button press ripple
 *
 * On press, a soft ring of light spreads out from the point the finger or
 * pointer touched. It starts on pointerdown rather than click, so it is
 * visible before the browser begins navigating away, and navigation is never
 * delayed to make room for it.
 *
 * Several homepage sections load this file, so the listener is guarded and
 * binds once. Nothing runs for a visitor who asks for reduced motion or who has
 * switched on the accessibility menu's stop-motion setting.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__solvexLuxRipple) return;
  window.__solvexLuxRipple = true;

  function lessMotion() {
    if (document.documentElement.classList.contains('sx-a11y-stop-motion')) return true;
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    var button = event.target.closest ? event.target.closest('.solvex-lux-btn') : null;
    if (!button || lessMotion()) return;

    var box = button.getBoundingClientRect();
    var size = Math.max(box.width, box.height) * 2.2;
    var ring = document.createElement('span');
    ring.className = 'solvex-lux-btn__ripple';
    ring.setAttribute('aria-hidden', 'true');
    ring.style.width = ring.style.height = size + 'px';
    ring.style.left = (event.clientX - box.left - size / 2) + 'px';
    ring.style.top = (event.clientY - box.top - size / 2) + 'px';
    button.appendChild(ring);

    ring.addEventListener('animationend', function () {
      if (ring.parentNode) ring.parentNode.removeChild(ring);
    });
    // Belt and braces: a backgrounded tab may never fire animationend.
    window.setTimeout(function () {
      if (ring.parentNode) ring.parentNode.removeChild(ring);
    }, 1200);
  });
})();
